import { Link } from "react-router-dom";
import { categoryMeta, videos, type VideoCategory } from "@/mocks/videos";

const entries: { type: VideoCategory; image: string; icon: string }[] = [
  {
    type: "movie",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20cinema%20auditorium%20with%20rows%20of%20plush%20seats%20and%20a%20bright%20glowing%20screen%2C%20warm%20amber%20accent%20lighting%20along%20the%20aisles%2C%20deep%20blue%20shadows%2C%20cinematic%20atmosphere%2C%20clean%20professional%20photography%20style&width=800&height=560&seq=cat-movie-2026&orientation=landscape",
  },
  {
    type: "tv",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20at%20evening%20with%20a%20large%20television%20screen%20glowing%20softly%2C%20comfortable%20sofa%20and%20warm%20floor%20lamp%2C%20cool%20blue%20ambient%20shadows%20with%20amber%20highlights%2C%20inviting%20calm%20mood%2C%20clean%20photography&width=800&height=560&seq=cat-tv-2026&orientation=landscape",
  },
  {
    type: "variety",
    icon: "ri-mic-line",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20spotlights%20and%20glowing%20LED%20panels%2C%20confetti%20and%20stage%20props%2C%20energetic%20blue%20and%20warm%20orange%20lighting%2C%20festive%20cheerful%20atmosphere%2C%20clean%20professional%20photography&width=800&height=560&seq=cat-variety-2026&orientation=landscape",
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {entries.map((entry) => {
        const meta = categoryMeta[entry.type];
        const count = videos.filter((v) => v.category === entry.type).length;
        return (
          <Link
            key={entry.type}
            to={`/category/${meta.slug}`}
            className="group relative rounded-lg overflow-hidden h-44 md:h-52 border border-background-200 hover:border-primary-300 transition-colors"
          >
            <img
              src={entry.image}
              alt={`${meta.label}频道入口`}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent"></div>
            <div className="relative z-10 h-full flex flex-col justify-end p-5">
              <span className="w-11 h-11 rounded-lg bg-primary-500 text-white flex items-center justify-center mb-3">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading font-bold text-xl text-white">{meta.label}</h3>
              <p className="text-xs text-white/75 mt-1 line-clamp-1">{meta.intro}</p>
              <p className="text-xs text-accent-400 mt-2 flex items-center gap-1">
                {count} 部精选内容
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}